import { useState, useEffect } from 'react';
import { getVisibilitySettings, VisibilitySettings } from '../functions/visibilityService';

interface UseVisibilityReturn {
  visibility: VisibilitySettings | null;
  loading: boolean;
  error: string | null;
  refreshVisibility: () => Promise<void>;
}

export function useVisibility(): UseVisibilityReturn {
  const [visibility, setVisibility] = useState<VisibilitySettings | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const refreshVisibility = async () => {
    try {
      setLoading(true);
      setError(null);
      const settings = await getVisibilitySettings();
      setVisibility(settings);
    } catch (err) {
      setError('Failed to load visibility settings');
      console.error('Error loading visibility settings:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    refreshVisibility();
  }, []);

  return {
    visibility,
    loading,
    error,
    refreshVisibility,
  };
}
